import DynamicForm from '@components/shared-ui-components/DynamicForm'
import { Paper } from '@mui/material'

function AutoLabellingPage() {

  return (
    <Paper
      elevation={3} // Add shadow effect
      sx={{
        padding: '20px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <h4>Please fill up the Auto Labelling form</h4>
      <DynamicForm page={'autoLabelling'} />
    </Paper>
  )
}

export default AutoLabellingPage